export default __webpack_public_path__ + "static/media/filtersOpen.1b2f3d70.svg";